// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutShippingOrderNotesEntryStyles } from "@tps/Overrides/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry";
import xScreen from "@tps/XDL/Utilities/xScreen";
import { css } from "styled-components";

checkoutShippingOrderNotesEntryStyles.textArea = {
    css: css`
        min-width: 100%;
        max-width: 100%;
        min-height: 50px;
    `,
    cssOverrides: {
        formField: css`
            margin-top: 16px;
            width: 430px;
            max-width: 100%;
            ${xScreen("lte", "md")} {
                width: 360px;
            }
            ${xScreen("lte", 767)} {
                width: 100%;
            }
        `,
    },
};
